export var LocationType;
(function (LocationType) {
    LocationType[LocationType["None"] = 0] = "None";
    LocationType[LocationType["Municipality"] = 1] = "Municipality";
    LocationType[LocationType["Region"] = 2] = "Region";
    LocationType[LocationType["Abroad"] = 3] = "Abroad";
    LocationType[LocationType["Nationwide"] = 4] = "Nationwide";
    LocationType[LocationType["WellbeingServiceCounty"] = 5] = "WellbeingServiceCounty";
})(LocationType || (LocationType = {}));
